module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'Καλωσόρισες στο εργαστήριο χαρακτικής. Κάνε κλικ πάνω στα εργαλεία για να μάθεις τα ονόματά τους.',
        classes: 'man_tooltip'
      }),
      expression: "{ content: 'Καλωσόρισες στο εργαστήριο χαρακτικής. Κάνε κλικ πάνω στα εργαλεία για να μάθεις τα ονόματά τους.', classes: 'man_tooltip' }"
    }],
    staticClass: "clsm-2"
  }, [_c('clipPath', {
    attrs: {
      "id": "clip-pathm"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M636.3,299.3v-.7h0v-.3a13.7,13.7,0,1,0-26.9,3.3c.8,6.7,2.5,21.7,3.2,24a11,11,0,0,0,21.6-2.6c0-.2,0-.4,0-.5l2-22.7Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-2"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M644.4,310.8c.8-1,2-2.6,1.7-3.6-2.4-.3-4.5.1-6.8-.7-4-1.3-7.6-3.3-11.9-4a26.9,26.9,0,0,0-13.8,1.4,13.6,13.6,0,0,0-5.8,4.7h0c-.9.2-2.7,2.4-3,2.8a11.1,11.1,0,0,0-1.5,3.5l-1.9,5,1.7-.6c.1.6.1,1.3.3,1.9a59.6,59.6,0,0,0,1.5,6.3,2.6,2.6,0,0,0-1.5.9,2.7,2.7,0,0,0-.2,2c.4,2.5,3.1,4.7,6.4,4.7h0a11.9,11.9,0,0,0,1.9,6.4c2.1,3.1,5.8,7.1,10.3,6.7h4.7c4.5.4,8.2-3.5,10.3-6.7a9.5,9.5,0,0,0,1.4-6.4h0a6.2,6.2,0,0,0,5.6-4.6,2.7,2.7,0,0,0-.2-2,2.6,2.6,0,0,0-1.5-.9,59.5,59.5,0,0,0,1.5-6.3,15.7,15.7,0,0,0-.1-7.1,9.7,9.7,0,0,0,2.2-3.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-3"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M653,313c-1.3-1.4-1.2-5.2-1.2-5.2v-5.1h-1l2.2-7.6-3-.7-2.4,8.3H634l-2.4-8.3-3,.7,2.2,7.6h-1v5.1s3,5.2-.4,7.6a7.4,7.4,0,0,1-4.3,1,17.6,17.6,0,0,1,1.4,5.5,8,8,0,0,1-1.4,4.5l-1.2,13.9,1.3,8.7h31.3V314.7A6.2,6.2,0,0,1,653,313Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-4"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M645.3,279.2c.9-1.3,2.2-3.3,2-4.6-2.4-.5-4.5-.2-6.7-1.3-3.9-1.9-7.3-4.8-11.6-5.9a21,21,0,0,0-13.9,1,15.2,15.2,0,0,0-6.1,5.8v.2c-.9.3-2.9,2.9-3.2,3.5a17.4,17.4,0,0,0-1.7,4.5l-2.3,6.4,1.8-.6c0,.8,0,1.7.1,2.5.2,2.7.5,5.5,1,8.3a2.7,2.7,0,0,0-1.6,1.1,4.5,4.5,0,0,0-.4,2.6c.2,3.2,2.7,6.4,6,6.5h0a19.6,19.6,0,0,0,1.4,8.6c1.8,4.2,5.2,9.6,9.7,9.4h2.3l2.3.3c4.5.8,8.5-4.1,10.8-8.1a15.9,15.9,0,0,0,1.9-8.3h0c2.9-.2,5.4-2.8,6-5.7a4.5,4.5,0,0,0-.1-2.6,2.7,2.7,0,0,0-1.4-1.3c.8-2.7,1.5-5.4,2-8.1a27,27,0,0,0,.5-9.3,14,14,0,0,0,2.4-4.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-5"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M653.8,282.7c-1.2-1.9-.7-6.9-.7-6.9l.4-6.6h-1l2.9-9.9-3-1-3,10.7-13.7-.8L634,257l-3.1.7,1.6,10.2h-1l-.4,6.6s2.6,7-1,9.9a6,6,0,0,1-4.3,1.1,29.1,29.1,0,0,1,.9,7.3,12.7,12.7,0,0,1-1.8,5.8l-2.3,18.2.6,11.4,6.6.4,18,1.1,6.6.4,2.7-44.9A5.6,5.6,0,0,1,653.8,282.7Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-6"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M654.4,397.2c-3.2-5.5-3-21.2-3-21.2V355.6h-2.6l5.7-30.9-7.8-2.6-6,33.6H605.9l-6-33.6-7.8,2.6,5.7,30.9h-2.6V376s.2,15.7-3,21.2a14.1,14.1,0,0,1-8.8,6.9V542.7h79.8V404.1A14.1,14.1,0,0,1,654.4,397.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-8"
    }
  }, [_c('polygon', {
    staticClass: "clsm-1",
    attrs: {
      "points": "648 360.6 648.9 355.6 654.6 324.6 646.8 322 640.4 358.6 606.5 358.6 599.9 322 592.2 324.6 598.8 360.6 606.6 359.2 640.2 359.2 648 360.6"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-9"
    }
  }, [_c('polygon', {
    staticClass: "clsm-1",
    attrs: {
      "points": "648 360.6 648.9 355.6 654.6 324.6 646.8 322 640.4 358.6 606.6 359.2 599.9 322 592.2 324.6 598.8 360.6 606.6 359.2 640.2 359.2 648 360.6"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-10"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M638,301v-.7h0v-.3a13.7,13.7,0,1,0-27.1,2.3c.5,6.7,1.7,21.8,2.4,24.1a11,11,0,0,0,21.7-1.8c0-.2,0-.4,0-.5l2.9-22.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-11"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M645.7,312.8c.9-1,2.1-2.5,1.8-3.5-2.4-.3-4.5-.1-6.8-.9-3.9-1.4-7.5-3.6-11.7-4.4a26.9,26.9,0,0,0-13.8.9,13.6,13.6,0,0,0-5.9,4.4h0c-.9.2-2.8,2.3-3.1,2.7a11.1,11.1,0,0,0-1.6,3.5l-2.1,4.9,1.8-.5c0,.6.1,1.3.2,1.9a59.6,59.6,0,0,0,1.3,6.3,2.6,2.6,0,0,0-1.5.9,2.7,2.7,0,0,0-.3,2c.4,2.5,2.9,4.9,6.2,4.9h0a11.9,11.9,0,0,0,1.7,6.5c1.9,3.2,5.5,7.3,10,7.1h2.3l2.3.2c4.5.6,8.4-3.2,10.5-6.3a9.5,9.5,0,0,0,1.7-6.4h0a6.2,6.2,0,0,0,5.8-4.4,2.7,2.7,0,0,0-.2-2,2.6,2.6,0,0,0-1.5-1,59.5,59.5,0,0,0,1.7-6.2,15.7,15.7,0,0,0,.2-7.1,9.7,9.7,0,0,0,2.3-3.4Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-12"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M654.3,315.3c-1.2-1.4-1-5.3-1-5.3l.2-5.1h-1l2.5-7.6-3-.8-2.7,8.2-13.7-.5-2-8.4-3.1.5,2,7.7h-1l-.2,5.1s2.8,5.3-.6,7.6a7.4,7.4,0,0,1-4.3.9,17.6,17.6,0,0,1,1.1,5.6,8,8,0,0,1-1.6,4.5l-1.7,13.9,1,8.7,6.6.2,18,.7,6.6.2,1.3-34.3A6.2,6.2,0,0,1,654.3,315.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-13"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M655.8,278.8c1.3-1,3-2.6,3.2-3.8-2.2-1.1-4.3-1.4-6.1-3.1s-5.7-6.7-9.5-8.9a21,21,0,0,0-13.6-2.8,15.2,15.2,0,0,0-7.5,3.8v.2c-1,0-3.6,2-4.1,2.5a17.5,17.5,0,0,0-2.9,3.9l-4,5.5h1.9c-.2.8-.4,1.6-.6,2.4-.5,2.7-1,5.5-1.3,8.2a2.7,2.7,0,0,0-1.8.7,4.5,4.5,0,0,0-1.1,2.4c-.7,3.2.9,6.9,4,7.9h0a19.6,19.6,0,0,0-1,8.6c.6,4.6,2.3,10.7,6.8,11.7l2.3.6,2.2.9c4.1,2,9.3-1.6,12.6-4.8a15.9,15.9,0,0,0,4.2-7.5h.1c2.9.6,6-1.2,7.3-3.9a4.5,4.5,0,0,0,.6-2.5,2.7,2.7,0,0,0-1-1.7c1.5-2.4,2.9-4.8,4.2-7.2a27,27,0,0,0,3-8.8,14,14,0,0,0,3.6-3.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-14"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M662.9,284.5c-.6-2.1,1.2-6.9,1.2-6.9l2.2-6.3-.9-.3,5.5-8.7-2.6-1.8-5.9,9.5-12.9-4.6,1.4-11.1-3.2-.2-1.3,10.2-1-.3-2.2,6.3s.6,7.5-3.7,9.3a6,6,0,0,1-4.5-.2,29.1,29.1,0,0,1-1.2,7.3,12.7,12.7,0,0,1-3.3,5.1l-7.3,16.8-2.6,11.1,6.2,2.2,17,6,6.2,2.2,15.1-42.4A5.6,5.6,0,0,1,662.9,284.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-15"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M652.5,399.5c-3-5.6-2.2-21.3-2.2-21.3l.8-20.5h-2.6l6.9-30.7-7.7-2.9-7.2,33.3-34.9-1.3-4.8-33.8-7.9,2.3,4.6,31.1H595l-.8,20.5s-.3,15.7-3.8,21.1a14.1,14.1,0,0,1-9.1,6.5l-5.1,138.5,16.9.6,46,1.7,16.9.6,5.1-138.5A14.1,14.1,0,0,1,652.5,399.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-17"
    }
  }, [_c('polygon', {
    staticClass: "clsm-1",
    attrs: {
      "points": "647.4 362.7 648.5 357.7 655.4 327 647.7 324.1 639.9 360.4 606.1 359.2 600.8 322.3 593 324.7 598.3 360.9 606.1 359.8 639.7 361 647.4 362.7"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-18"
    }
  }, [_c('polygon', {
    staticClass: "clsm-1",
    attrs: {
      "points": "647.4 362.7 648.5 357.7 655.4 327 647.7 324.1 639.9 360.4 606.1 359.8 600.8 322.3 593 324.7 598.3 360.9 606.1 359.8 639.7 361 647.4 362.7"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-19"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M631.9,300v-.7h0c0-.1,0-.2,0-.3a13.7,13.7,0,1,0-26.9,3.8c.9,6.7,3,21.7,3.7,24a11,11,0,0,0,21.5-3c0-.2,0-.4,0-.5l1.6-22.7Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-20"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M640.3,311.3c.8-1.1,1.9-2.6,1.6-3.6-2.4-.2-4.5.2-6.8-.5-4-1.2-7.7-3.2-12-3.7a26.9,26.9,0,0,0-13.7,1.7,13.6,13.6,0,0,0-5.7,4.8h0c-.9.3-2.7,2.4-3,2.9a11.1,11.1,0,0,0-1.4,3.6l-1.9,5,1.7-.6c.1.6.2,1.3.3,1.9a59.6,59.6,0,0,0,1.6,6.2,2.6,2.6,0,0,0-1.5,1,2.7,2.7,0,0,0-.2,2c.5,2.4,3.2,4.7,6.5,4.5h0a11.9,11.9,0,0,0,2,6.4c2.1,3.1,5.9,7,10.4,6.5l2.3-.2h2.3c4.5.3,8.2-3.7,10.2-6.9a9.5,9.5,0,0,0,1.3-6.5h0a6.2,6.2,0,0,0,5.5-4.8,2.7,2.7,0,0,0-.3-2,2.6,2.6,0,0,0-1.5-.9,59.5,59.5,0,0,0,1.4-6.3,15.7,15.7,0,0,0-.2-7.1,9.7,9.7,0,0,0,2.1-3.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-21"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M649,313.4c-1.3-1.3-1.3-5.2-1.3-5.2v-5.1h-1l2.1-7.7-3.1-.6-2.2,8.3-13.7.3-2.5-8.3-3,.7,2.4,7.6h-1v5.1s3.1,5.1-.2,7.6a7.4,7.4,0,0,1-4.2,1.1,17.6,17.6,0,0,1,1.5,5.5,8,8,0,0,1-1.3,4.5l-1,14,1.5,8.6h6.6l18-.4h6.6l-.7-34.3A6.2,6.2,0,0,1,649,313.4Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-22"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M634.8,267.9c.7-1.4,1.7-3.6,1.3-4.8-2.4-.1-4.5.5-6.9-.3-4.1-1.3-7.9-3.7-12.3-4.1a21,21,0,0,0-13.5,3.1,15.2,15.2,0,0,0-5.2,6.6v.2c-.9.4-2.4,3.3-2.7,3.9a17.4,17.4,0,0,0-1,4.8l-1.4,6.7,1.7-.9c.1.8.3,1.6.5,2.4.6,2.6,1.4,5.4,2.2,8.1a2.7,2.7,0,0,0-1.4,1.4,4.5,4.5,0,0,0,0,2.6c.7,3.2,3.7,5.9,6.9,5.5h0a19.6,19.6,0,0,0,2.6,8.3c2.4,3.9,6.6,8.7,11,7.8l2.3-.4h2.3c4.6.1,7.8-5.4,9.5-9.7a15.9,15.9,0,0,0,.7-8.5h0c2.9-.6,4.9-3.6,5-6.6a4.5,4.5,0,0,0-.5-2.6,2.7,2.7,0,0,0-1.6-1.1c.4-2.8.6-5.6.8-8.3a27,27,0,0,0-.9-9.2,14,14,0,0,0,1.7-4.8Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-23"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M643.7,270.1c-1.4-1.7-1.8-6.8-1.8-6.8l-.6-6.6h-1l1.3-10.2-3.1-.6-1.4,11.1-13.6,1.2-3.3-10.6-3,1.1,3.1,9.8h-1l.6,6.6s3.6,6.5.5,9.9a6,6,0,0,1-4.1,1.7,29.1,29.1,0,0,1,2,7.1,12.7,12.7,0,0,1-.9,6l.4,18.3,2.3,11.2,6.6-.6,18-1.6,6.6-.6-4-44.8A5.6,5.6,0,0,1,643.7,270.1Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-24"
    }
  }, [_c('path', {
    staticClass: "clsm-1",
    attrs: {
      "d": "M652,397.6c-3.3-5.4-3.4-21.2-3.4-21.2l-.4-20.5h-2.6l5.1-31-7.8-2.5-5.3,33.7-34.9.7-6.7-33.4-7.7,2.8,6.3,30.8h-2.6l.4,20.5s.6,15.7-2.6,21.3a14.1,14.1,0,0,1-8.7,7l2.7,138.6,16.9-.3,46-.9,16.9-.3L661,404.3A14.1,14.1,0,0,1,652,397.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-26"
    }
  }, [_c('polygon', {
    staticClass: "clsm-1",
    attrs: {
      "points": "644.8 361.1 645.7 356 650.8 325 643 322.5 637.2 359.3 603.4 359.9 596.1 323.4 588.3 326.2 595.7 362.1 603.4 360.5 637 359.9 644.8 361.1"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-pathm-27"
    }
  }, [_c('polygon', {
    staticClass: "clsm-1",
    attrs: {
      "points": "644.8 361.1 645.7 356 650.8 325 643 322.5 637.2 359.3 603.4 360.5 596.1 323.4 588.3 326.2 595.7 362.1 603.4 360.5 637 359.9 644.8 361.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "man man--idle",
    class: {
      active: _vm.man.idle
    },
    attrs: {
      "id": "man_idle"
    },
    on: {
      "click": _vm.switchPosition
    }
  }, [_c('g', {
    attrs: {
      "id": "r_foot"
    }
  }, [_c('g', [_c('path', {
    staticClass: "clsm-3",
    attrs: {
      "d": "M596.2,566.9l6.2,48.3s.7,17.6.8,17.6l.9,6.3,8.1,2.2h0l5.3-51.1,2.8-25.9Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "608",
      "cy": "565.5",
      "r": "12"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "clsm-4",
    attrs: {
      "points": "615 633.6 599.8 632.8 600.2 640.1 581.8 652 610.5 650.4 615 649.5 612.1 641.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-5",
    attrs: {
      "d": "M601.7,646.9s-4-13.4-5.7-10.4,4,7.5,4,7.5l6.8-4.9s-4.8-1.1-5.8,2.8a6.9,6.9,0,0,1-4.5,4.8"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-3",
    attrs: {
      "points": "588.7 470.7 596.2 566.9 620.2 564.3 621.6 542.6 624.2 517.3 631 458.1 592.3 458.1 588.7 470.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "608",
      "cy": "565.5",
      "r": "12"
    }
  })]), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "612.9",
      "cy": "465.1",
      "r": "21.8"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "clsm-3",
    attrs: {
      "d": "M650.4,566.9l-6.2,48.3s-.7,17.6-.8,17.6l-.9,6.3-8.1,2.2h0l-5.3-51.1-2.3-23.8Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "638.7",
      "cy": "565.5",
      "r": "11.8"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "clsm-4",
    attrs: {
      "points": "630.5 633.6 645.7 632.8 645.3 640.1 663.7 652 635 650.4 630.5 649.5 633.4 641.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-5",
    attrs: {
      "d": "M642.5,646.9s4-13.4,5.7-10.4-4,7.5-4,7.5l-6.8-4.9s4.8-1.1,5.8,2.8a6.9,6.9,0,0,0,4.4,4.8"
    }
  })]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "clsm-3",
    attrs: {
      "points": "658 470.7 650.5 565.8 627 564.1 625.2 542.6 622.6 517.3 615.8 458.1 654.5 458.1 658 470.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "638.6",
      "cy": "565.5",
      "r": "11.8"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "633.9",
      "cy": "465.1",
      "r": "21.8"
    }
  })])]), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "623.4",
      "cy": "458.3",
      "r": "31.4"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "592",
      "cy": "339.5",
      "r": "14.2",
      "transform": "translate(237.1 922.4) rotate(-88.5)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "655",
      "cy": "339.5",
      "r": "14.2",
      "transform": "translate(298.4 985.4) rotate(-88.5)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M623,351.1l23.3-26.6-24.8-9.6-23.3,10.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M665.8,338.4a11.2,11.2,0,0,0-5-9h-.2a11.1,11.1,0,0,0-3.5-1.4L639,320.4s-3.1,15-15.2,16.4h-1c-12-1.4-15.1-16.4-15.1-16.4l-18.1,7.3a11.2,11.2,0,0,0-3.5,1.4h-.2A11.1,11.1,0,0,0,586,348l.2,118.9h74.6V348A11.1,11.1,0,0,0,665.8,338.4Z"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M636.3,298.6l-27.3-.3s2.7,24.3,3.6,27.3a11,11,0,0,0,21.6-2.6c0-.2,0-.4,0-.5Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "622.6",
      "cy": "298.1",
      "r": "13.7",
      "transform": "translate(318 917.5) rotate(-89.4)"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "clsm-8"
  }, [_c('g', {
    staticClass: "clsm-9"
  }, [_c('g', {
    staticClass: "clsm-10"
  }, [_c('g', {
    staticClass: "clsm-11"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.01, -0.03, 0.01, 651.33, 292.53)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.01, 0.02, 0.01, 597.47, 309.18)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M624.7,274.5h-.3c-8.5-.3-23,8.4-18,23.8,1.9,5.9,1.9,11.4,3.7,16s3.8,9.1,6.6,11.5,3.5,1.4,5.6,1.5h.3c2.1.1,4,.3,5.7-1s5.6-6,7.5-10.9,2.8-9.9,5.2-15.6C647.1,284.6,633.2,274.9,624.7,274.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M638.3,303.2a2.9,2.9,0,0,0,0-1.1c-.3-1.3-1.2-2.3-1.1-3.7s.8-2.4,1.3-3.5a13.6,13.6,0,0,0,.2-8.6c-.4-1.6-1.5-3-1.8-4.6s1.3-2.9,2.3-4.4.3-1,.6-1.2,2.7,3,2.9,3.7c1.8,4.1,1.6,8.8.8,13.1a82.9,82.9,0,0,1-3.1,12.5,15.4,15.4,0,0,0-.8,2.9c-.1.5-1.6-1.1-1.7-1.4S638.2,304.4,638.3,303.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M607.7,301a2.9,2.9,0,0,1,.1-1.1c.4-1.2,1.3-2.2,1.4-3.6s-.6-2.4-1-3.6a13.6,13.6,0,0,1,.5-8.6c.6-1.6,1.6-2.9,2-4.5s.5-3.8-.6-5.3a1.4,1.4,0,0,0-1.7-.4c-.9.3-2.8,3-3.2,3.6-2.1,4-2.4,8.4-1.9,12.8a82.9,82.9,0,0,0,2.1,12.7,15.4,15.4,0,0,1,.6,2.9c0,.5,1.7-.9,1.8-1.2S607.8,302.2,607.7,301Z"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-13",
    attrs: {
      "points": "604.6 280.3 601.7 288.9 604.6 287.8"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-13",
    attrs: {
      "points": "609 280.6 612 282.7 612.2 274.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M646.8,274.3c-2.4-.4-4.5-.1-6.8-1.2-3.9-1.9-7.4-4.7-11.7-5.7a21,21,0,0,0-13.8,1.3,15.2,15.2,0,0,0-6,5.9v.2c-.9,4.3,2.8,5.5,4.6,5.8a12.2,12.2,0,0,0,2,.3,18.1,18.1,0,0,1,3.4,1.2,43.7,43.7,0,0,1,6.6,3.3,25.3,25.3,0,0,0,5,2.8c2.1.8,4.7,1.6,6.9.5a12.2,12.2,0,0,1-2.4-2.3,11.4,11.4,0,0,1-1.4-2.6c.9.8,2,1.6,2.9,2.3a4.8,4.8,0,0,0,4.2.5c2.4-.9,5.2-4.9,5.9-7.6l-1.3-.2C645.8,277.5,647,275.5,646.8,274.3Z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "glasses"
    }
  }, [_c('circle', {
    staticClass: "clsm-14",
    attrs: {
      "cx": "616.3",
      "cy": "300.4",
      "r": "4",
      "transform": "translate(291.9 904.4) rotate(-87.7)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-14",
    attrs: {
      "cx": "630",
      "cy": "300.8",
      "r": "4",
      "transform": "translate(304.6 918.4) rotate(-87.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-15",
    attrs: {
      "d": "M620.8,299.2a3.9,3.9,0,0,1,4.8.2"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "clsm-16",
    attrs: {
      "x": "633.9",
      "y": "300",
      "width": "2.8",
      "height": "1.8",
      "transform": "translate(309.5 923.8) rotate(-87.7)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "clsm-16",
    attrs: {
      "x": "609.8",
      "y": "299.1",
      "width": "2.8",
      "height": "1.8",
      "transform": "translate(287.3 898.9) rotate(-87.7)"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "clsm-15",
    attrs: {
      "x1": "610.7",
      "y1": "300",
      "x2": "604.3",
      "y2": "301.1"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "clsm-15",
    attrs: {
      "x1": "635.1",
      "y1": "300.6",
      "x2": "640.7",
      "y2": "301.9"
    }
  })]), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-17",
    attrs: {
      "id": "r_eyebrow",
      "points": "634.9 295.1 630.7 293.7 626.6 294.5"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-17",
    attrs: {
      "id": "l_eyebrow",
      "points": "612.4 294.2 616.7 293.1 620.8 294.3"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_eye"
    }
  }, [_c('circle', {
    staticClass: "clsm-16",
    attrs: {
      "cx": "616.3",
      "cy": "302.5",
      "r": "1.8",
      "transform": "translate(289.7 906.4) rotate(-87.7)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-18",
    attrs: {
      "cx": "615.6",
      "cy": "301.9",
      "r": "0.3",
      "transform": "translate(289.6 905.2) rotate(-87.7)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "r_eye"
    }
  }, [_c('circle', {
    staticClass: "clsm-16",
    attrs: {
      "cx": "629.9",
      "cy": "302.9",
      "r": "1.8",
      "transform": "translate(302.4 920.4) rotate(-87.7)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-18",
    attrs: {
      "cx": "629.1",
      "cy": "302.3",
      "r": "0.3",
      "transform": "translate(302.2 919) rotate(-87.7)"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-19",
    attrs: {
      "id": "l_vlefaro",
      "d": "M618.1,302.1a1.8,1.8,0,0,0-1.7-1.3,1.8,1.8,0,0,0-1.8,1.2,1.8,1.8,0,1,1,3.5.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-19",
    attrs: {
      "id": "r_vlefaro",
      "d": "M631.7,302.5a1.8,1.8,0,0,0-1.7-1.3,1.8,1.8,0,0,0-1.8,1.2,1.8,1.8,0,0,1,3.5.1Z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "nose"
    }
  }, [_c('path', {
    staticClass: "clsm-20",
    attrs: {
      "d": "M622.2,310.8l5.2-1.4a29.5,29.5,0,0,0-4.9-9.1Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-20",
    attrs: {
      "cx": "621.9",
      "cy": "309.1",
      "r": "1.8",
      "transform": "translate(288.6 918.3) rotate(-87.7)"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-21",
    attrs: {
      "d": "M629.9,318.8l-.6-4.6-3.8-3.2-2.2.4-2.2-.5-4,3-.8,4.2-7.5-8.5a19.6,19.6,0,0,0,1.6,8.5c1.9,4.2,5.4,9.5,9.9,9.2h2.3l2.3.3c4.5.7,8.4-4.3,10.6-8.4a15.9,15.9,0,0,0,1.8-8.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M637.5,303.4c.5.5,2.7-2.2,3.6-2.3s1.4.8,1.6,1.3a4.5,4.5,0,0,1,.1,2.6c-.6,3.6-4.1,6.8-7.9,5.6.1-.2.2,0,.4,0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M608.6,301.7c-.5.4-2.6-2.5-3.5-2.6s-1.5.7-1.7,1.2a4.5,4.5,0,0,0-.3,2.6c.4,3.6,3.5,7.1,7.4,6.2-.1-.2-.2-.1-.4,0"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "clsm-22"
  }, [_c('g', {
    staticClass: "clsm-10"
  }, [_c('g', {
    staticClass: "clsm-23"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.02, -0.03, 0, 662.09, 267.76)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0.01, 0, 0.01, 0.03, 605.42, 292.32)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "599.9 322 592.2 324.6 598.8 360.6 606.6 359.2 599.9 322"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "646.8 322 654.6 324.6 648 360.6 640.2 359.2 646.8 322"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-24",
    attrs: {
      "d": "M654.4,397.2c-3.2-5.5-3-21.2-3-21.2V355.6H595.3V376s.2,15.7-3,21.2a14.1,14.1,0,0,1-8.8,6.9V542.7h79.8V404.1A14.1,14.1,0,0,1,654.4,397.2Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "clsm-25"
  }, [_c('g', {
    staticClass: "clsm-26"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.07, 0.07, 0.01, 557.47, 444.68)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "clsm-27"
  }, [_c('g', {
    staticClass: "clsm-26"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.06, -0.07, 0.01, 682.09, 349.16)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0, 0.07, -0.07, 0.01, 680.52, 420.87)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "599.9 322 592.2 324.6 598.8 360.6 606.6 359.2 599.9 322"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "646.8 322 654.6 324.6 648 360.6 640.2 359.2 646.8 322"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "clsm-25"
  }, [_c('g', {
    staticClass: "clsm-28"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.07, 0.07, 0.01, 557.47, 444.68)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "clsm-27"
  }, [_c('g', {
    staticClass: "clsm-29"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.06, -0.07, 0.01, 682.09, 349.16)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0, 0.07, -0.07, 0.01, 680.52, 420.87)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "660.2",
      "cy": "335.4",
      "r": "7.3",
      "transform": "translate(-8.6 17.4) rotate(-1.5)"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "r_upper_arm"
    }
  }, [_c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M686.8,394.9l.9-19.2a16.5,16.5,0,0,0-15.7-17.3c-9.1-.4-9.8,6-10.3,15.1a10.7,10.7,0,0,0,1.9,6.9l7.3,19.8a9,9,0,0,0,15.8-5.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M660.2,379.4v-2.1c0-.8.1-1.6.1-2.4s0-3.2-.1-4.8a49,49,0,0,0-1.2-8.8A25.9,25.9,0,0,0,658,358a14.3,14.3,0,0,0-1.2-2.3,4.4,4.4,0,0,0-.8-1l-.6-.4,5.4-26.2a29.4,29.4,0,0,1,10,4,30.3,30.3,0,0,1,7.6,6.9,40.1,40.1,0,0,1,4.7,7.6,52.5,52.5,0,0,1,2.8,7.4,76.1,76.1,0,0,1,2.7,13.9c.2,2.3.4,4.5.5,6.7s.1,2.2.1,3.4v3.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M685.1,366.4v-1.5l.2-1.1c.1-.7.2-1.3.2-2a34.7,34.7,0,0,0,.1-4,32.9,32.9,0,0,0-1.4-8.4,27,27,0,0,0-4.5-8.7l-1.7-2-1.9-1.7-1-.8-1-.7-2.1-1.3a13.4,13.4,0,0,0-18.4,4.5c-3.8,6.3,3.2,20.2,3.2,20.2a79.3,79.3,0,0,1,3.3,17.1C668.2,378.1,683.1,374.1,685.1,366.4Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_upper_arm"
    }
  }, [_c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "586.5",
      "cy": "335.4",
      "r": "7.3",
      "transform": "translate(235.8 912.9) rotate(-88.5)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M559.9,394.9l-.9-19.2a16.5,16.5,0,0,1,15.7-17.3c9.1-.4,9.8,6,10.3,15.1a10.7,10.7,0,0,1-1.9,6.9l-7.3,19.8a9,9,0,0,1-15.8-5.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M557.7,381.7V378c0-1.1,0-2.3.1-3.4s.2-4.5.5-6.7a76.1,76.1,0,0,1,2.7-13.9,52.5,52.5,0,0,1,2.8-7.4,40.1,40.1,0,0,1,4.7-7.6,30.3,30.3,0,0,1,7.6-6.9,29.4,29.4,0,0,1,10-4l5.4,26.2-.6.4a4.4,4.4,0,0,0-.8,1,14.3,14.3,0,0,0-1.2,2.3,25.9,25.9,0,0,0-1.1,3.5,49,49,0,0,0-1.2,8.8c-.1,1.6-.1,3.2-.1,4.8s0,1.6.1,2.4v2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M561.5,366.4v-1.5l-.2-1.1c-.1-.7-.2-1.3-.2-2a34.7,34.7,0,0,1-.1-4,32.9,32.9,0,0,1,1.4-8.4,27,27,0,0,1,4.5-8.7l1.7-2,1.9-1.7,1-.8,1-.7,2.1-1.3a13.4,13.4,0,0,1,18.4,4.5c3.8,6.3-3.2,20.2-3.2,20.2a79.3,79.3,0,0,0-3.3,17.1C578.5,378.1,563.6,374.1,561.5,366.4Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M668.2,470.3c-.4-6.3-.7-12.5-.9-18.8s-.3-12.5-.3-18.8,0-12.5.1-18.7.4-12.5,1.1-18.7a9.6,9.6,0,0,1,19.1,1.2c-.2,6.2-.7,12.5-1.2,18.7s-1.3,12.4-2.1,18.6-1.7,12.4-2.6,18.6-2,12.4-3.2,18.6a5,5,0,0,1-9.9-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M568.4,470.9c-1.2-6.2-2.2-12.4-3.1-18.6s-1.8-12.4-2.5-18.6-1.5-12.4-2.1-18.6-1-12.4-1.2-18.7a9.6,9.6,0,0,1,19.1-1.1c.6,6.2.8,12.5,1,18.7s.2,12.5.1,18.7-.2,12.5-.4,18.8-.5,12.5-.9,18.8a5,5,0,0,1-9.9.6Z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "r_hand"
    }
  }, [_c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M689.4,477.9a8.7,8.7,0,0,0-2.5-4.2c-2.2-1.7-6.1-1-12.1-4.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M690,481.3a6.4,6.4,0,0,0-2.1-3.3c-2.3-2.1-7.5-3.8-10.3-5.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M687,482.8a14.4,14.4,0,0,0-2.4-3.8c-2.1-2.3-6-2.9-8.5-4.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M682.2,483.3a7.2,7.2,0,0,0-1.3-2.4c-1.8-2.4-6.3-5.5-8.4-6.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M676.5,468.9c-4.1-.7-7.7.9-8.1,3.6s2.6,5.4,6.7,6.1,7.7-.9,8.1-3.6S680.6,469.6,676.5,468.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M672,471.8a8.1,8.1,0,0,0-.6,1.2l-.4,1.4a7.6,7.6,0,0,0-.2,2.6,5,5,0,0,0,.1.6v.5a4.4,4.4,0,0,0,.8,1,14.9,14.9,0,0,0,2.5,1.9h0a1.4,1.4,0,0,1-1.2,2.5,17.9,17.9,0,0,1-3.4-1.8,8.1,8.1,0,0,1-1.7-1.4l-.4-.5-.3-.5a8.7,8.7,0,0,1-.5-1,11.8,11.8,0,0,1-.7-4.3,17.9,17.9,0,0,1,.1-2.1,14.1,14.1,0,0,1,.4-2.1v-.3a2.9,2.9,0,1,1,5.6,1.6A3,3,0,0,1,672,471.8Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "671.7",
      "cy": "470",
      "rx": "4.7",
      "ry": "5"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "l_hand"
    }
  }, [_c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M557,478a8.7,8.7,0,0,1,2.5-4.2c2.2-1.7,6.1-1,12.1-4.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M556.3,481.4a6.4,6.4,0,0,1,2.1-3.3c2.3-2.1,7.5-3.8,10.3-5.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M559.3,482.8a14.4,14.4,0,0,1,2.4-3.8c2.1-2.3,6-2.9,8.5-4.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-30",
    attrs: {
      "d": "M564.1,483.4a7.2,7.2,0,0,1,1.3-2.4c1.8-2.4,6.3-5.5,8.4-6.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M569.8,469c4.1-.7,7.7.9,8.1,3.6s-2.6,5.4-6.7,6.1-7.7-.9-8.1-3.6S565.7,469.7,569.8,469Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M579.6,469.8a14.1,14.1,0,0,1,.4,2.1,17.9,17.9,0,0,1,.1,2.1,11.8,11.8,0,0,1-.7,4.3,8.7,8.7,0,0,1-.5,1l-.3.5-.4.5a8.1,8.1,0,0,1-1.7,1.4,17.9,17.9,0,0,1-3.4,1.8,1.4,1.4,0,0,1-1.2-2.5h0a14.9,14.9,0,0,0,2.5-1.9,4.4,4.4,0,0,0,.8-1v-.5a5,5,0,0,0,.1-.6,7.6,7.6,0,0,0-.2-2.6l-.4-1.4a8.1,8.1,0,0,0-.6-1.2,2.9,2.9,0,1,1,5.2-2.4Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "574.6",
      "cy": "470.1",
      "rx": "4.7",
      "ry": "5"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "lips"
    }
  }, [_c('polygon', {
    staticClass: "clsm-31",
    attrs: {
      "points": "619.1 316.4 622.3 314.2 623.1 316 624.1 314.2 627.1 316.8 619.1 316.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-31",
    attrs: {
      "points": "619 317 622.9 319.6 627.2 317.2 622.9 317.1 619 317"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "man man--thinking",
    class: {
      active: _vm.man.thinking
    },
    attrs: {
      "id": "man_thinking"
    },
    on: {
      "click": _vm.switchPosition
    }
  }, [_c('g', [_c('path', {
    staticClass: "clsm-3",
    attrs: {
      "d": "M648.4,567.9l-6.2,48.3s-.7,17.6-.8,17.6l-.9,6.3-8.1,2.2h0l-5.3-51.1-2.3-23.8Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "636.7",
      "cy": "566.5",
      "r": "11.8"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "clsm-3",
    attrs: {
      "d": "M594.2,567.9l6.2,48.3s.7,17.6.8,17.6l.9,6.3,8.1,2.2h0l5.3-51.1,2.8-25.9Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "606",
      "cy": "566.5",
      "r": "12"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "clsm-4",
    attrs: {
      "points": "628.5 634.6 643.7 633.8 643.3 641.1 661.7 653 633 651.4 628.5 650.5 631.4 642.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-5",
    attrs: {
      "d": "M640.5,647.9s4-13.4,5.7-10.4-4,7.5-4,7.5l-6.8-4.9s4.8-1.1,5.8,2.8a6.9,6.9,0,0,0,4.4,4.8"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "clsm-4",
    attrs: {
      "points": "613 634.6 597.8 633.8 598.2 641.1 579.8 653 608.5 651.4 613 650.5 610.1 642.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-5",
    attrs: {
      "d": "M599.7,647.9s-4-13.4-5.7-10.4,4,7.5,4,7.5l6.8-4.9s-4.8-1.1-5.8,2.8a6.9,6.9,0,0,1-4.5,4.8"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-3",
    attrs: {
      "points": "586.7 471.7 594.2 567.9 618.2 565.3 619.6 543.6 622.2 518.3 629 459.1 590.3 459.1 586.7 471.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "606",
      "cy": "566.5",
      "r": "12"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "610.9",
      "cy": "466.1",
      "r": "21.8"
    }
  }), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "clsm-3",
    attrs: {
      "points": "656 471.7 648.5 566.8 625 565.1 623.2 543.6 620.6 518.3 613.8 459.1 652.5 459.1 656 471.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "636.6",
      "cy": "566.5",
      "r": "11.8"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "631.9",
      "cy": "466.1",
      "r": "21.8"
    }
  })]), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "621.4",
      "cy": "459.3",
      "r": "31.4"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "592.3",
      "cy": "339.6",
      "r": "14.2",
      "transform": "translate(216 909.2) rotate(-86.4)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "655.2",
      "cy": "341.9",
      "r": "14.2",
      "transform": "translate(272.7 974.2) rotate(-86.4)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M622.8,352.2l24.3-25.7L622.7,316,599,325.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M666.1,341.1a11.2,11.2,0,0,0-4.7-9.2h-.2a11.1,11.1,0,0,0-3.5-1.6l-17.8-8s-3.7,14.9-15.7,15.8h-1c-12-1.8-14.5-16.9-14.5-16.9l-18.4,6.7a11.2,11.2,0,0,0-3.6,1.3h-.2a11.1,11.1,0,0,0-.6,18.7l-4.2,118.8,74.5,2.8,4.4-118.9A11.1,11.1,0,0,0,666.1,341.1Z"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M638.1,300.2l-27.3-1.3s1.8,24.3,2.6,27.4a11,11,0,0,0,21.7-1.8c0-.2,0-.4,0-.5Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "624.4",
      "cy": "299.3",
      "r": "13.7",
      "transform": "translate(295.8 908.7) rotate(-87.3)"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "clsm-32"
  }, [_c('g', {
    staticClass: "clsm-33"
  }, [_c('g', {
    staticClass: "clsm-10"
  }, [_c('g', {
    staticClass: "clsm-34"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.01, -0.03, 0.01, 653.3, 294.79)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.01, 0.02, 0.01, 598.87, 309.43)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M637.8,268.7h-.1v-.2c-8-2.9-24.5,1.2-24.3,17.4.1,6.2-1.5,11.4-1.2,16.4s.9,9.8,2.9,12.9,2.9,2.4,4.9,3.1h.3c2,.7,3.7,1.5,5.7.7s7.2-4.1,10.4-8.2,5.6-8.6,9.6-13.4C656.2,285,645.8,271.6,637.8,268.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M642.3,300.1a2.9,2.9,0,0,0,.3-1.1c.1-1.3-.4-2.6,0-3.9s1.5-2,2.3-3a13.6,13.6,0,0,0,2.8-8.1c.1-1.7-.6-3.3-.4-4.9s2.1-2.4,3.5-3.5.6-.9.9-.9,1.6,3.7,1.7,4.4c.5,4.5-1,8.8-3.1,12.8a82.9,82.9,0,0,1-6.7,11,15.4,15.4,0,0,0-1.7,2.5c-.2.5-1.2-1.5-1.2-1.8S641.8,301.2,642.3,300.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M613.4,289.9a2.9,2.9,0,0,1,.5-1.1c.8-1.1,1.9-1.7,2.4-3s.1-2.5.1-3.8a13.6,13.6,0,0,1,3-8c1-1.3,2.4-2.3,3.2-3.7s1.6-3.5,1-5.3a1.4,1.4,0,0,0-1.5-.9c-1,0-3.6,2-4.1,2.5-3.2,3.2-4.8,7.4-5.7,11.7a82.9,82.9,0,0,0-1.7,12.7,15.4,15.4,0,0,1-.3,3c-.1.5,1.9-.4,2.1-.6S613.2,291.1,613.4,289.9Z"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-13",
    attrs: {
      "points": "616.5 268.7 611.2 276 614.3 275.8"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-13",
    attrs: {
      "points": "618.8 273.2 621.1 276.1 623.6 268.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M658.9,275c-2.2-1.1-4.3-1.4-6.1-3.1s-5.7-6.7-9.5-8.9a21,21,0,0,0-13.6-2.8,15.2,15.2,0,0,0-7.5,3.8v.2c-2.1,3.8,1,6.1,2.6,6.9a12.2,12.2,0,0,0,1.8.9,18.1,18.1,0,0,1,2.9,2.1,43.7,43.7,0,0,1,5.3,5.1,25.3,25.3,0,0,0,3.9,4.2c1.7,1.4,4,3,6.5,2.5a12.2,12.2,0,0,1-1.6-2.9,11.4,11.4,0,0,1-.6-2.9c.6,1,1.4,2.1,2.1,3a4.8,4.8,0,0,0,3.8,1.7c2.6-.2,6.4-3.2,7.9-5.5l-1.2-.5C657,277.8,658.8,276.3,658.9,275Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-15",
    attrs: {
      "d": "M626.8,291.1a3.9,3.9,0,0,1,4.6,1.6"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "clsm-16",
    attrs: {
      "x": "616",
      "y": "288.1",
      "width": "2.8",
      "height": "1.8",
      "transform": "matrix(0.33, -0.94, 0.94, 0.33, 138.26, 773.87)"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "clsm-15",
    attrs: {
      "x1": "616.9",
      "y1": "288.9",
      "x2": "610.4",
      "y2": "288"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "clsm-15",
    attrs: {
      "x1": "640",
      "y1": "296.7",
      "x2": "644.9",
      "y2": "299.6"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-17",
    attrs: {
      "points": "641.7 290.4 638.2 287.9 634 287.4"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-17",
    attrs: {
      "points": "621.9 281.3 625.4 280.3 628.9 282.6"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "clsm-16",
    attrs: {
      "cx": "622.2",
      "cy": "289.4",
      "r": "1.8",
      "transform": "translate(141.1 778.7) rotate(-70.4)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-18",
    attrs: {
      "cx": "621.8",
      "cy": "288.6",
      "r": "0.3",
      "transform": "translate(141.6 777.9) rotate(-70.4)"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-19",
    attrs: {
      "d": "M624.1,289.5a1.8,1.8,0,0,0-1.2-1.8,1.8,1.8,0,0,0-2.1.6,1.8,1.8,0,0,1,3.3,1.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-20",
    attrs: {
      "d": "M624.6,302.6l5.3.2a29.5,29.5,0,0,0-1.9-10.2Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-20",
    attrs: {
      "cx": "624.9",
      "cy": "300.9",
      "r": "1.8",
      "transform": "translate(132.1 788.9) rotate(-70.4)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-21",
    attrs: {
      "d": "M629.6,312.5l.8-4.5-2.7-4.2-2.2-.3-1.9-1.1-4.8,1.7-2,3.8-4.6-10.3a19.6,19.6,0,0,0-1,8.6c.6,4.6,2.3,10.7,6.8,11.7l2.3.6,2.2.9c4.1,2,9.3-1.6,12.6-4.8a15.9,15.9,0,0,0,4.2-7.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-31",
    attrs: {
      "points": "620.5 307.1 624 305.3 624.2 307 625.4 305.8 627.2 309.6 620.5 307.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-31",
    attrs: {
      "points": "620.6 308 622.7 311.9 626.7 309.9 623.5 308.5 620.6 308"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M641.8,300.1c.3.6,3.3-1.3,4.2-1.1s1.1,1.2,1.2,1.7a4.5,4.5,0,0,1-.6,2.5c-1.7,3.3-5.9,5.3-9.2,3,.2-.1.2,0,.3.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M613.8,290.1c-.6.3-1.7-3.1-2.5-3.5s-1.6.2-2,.6a4.5,4.5,0,0,0-1.1,2.4c-.7,3.6,1.3,7.9,5.3,8.2-.1-.2-.2-.1-.4-.1"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "clsm-35"
  }, [_c('g', {
    staticClass: "clsm-10"
  }, [_c('g', {
    staticClass: "clsm-36"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.01, 0.02, -0.03, -0.01, 675.03, 272.45)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0.01, 0, 0, 0.03, 613.78, 280.37)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "600.8 322.3 593 324.7 598.3 360.9 606.1 359.8 600.8 322.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "647.7 324.1 655.4 327 647.4 362.7 639.7 361 647.7 324.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-24",
    attrs: {
      "d": "M652.5,399.5c-3-5.6-2.2-21.3-2.2-21.3l.8-20.5L595,355.7l-.8,20.5s-.3,15.7-3.8,21.1a14.1,14.1,0,0,1-9.1,6.5l-5.1,138.5,16.9.6,46,1.7,16.9.6,5.1-138.5A14.1,14.1,0,0,1,652.5,399.5Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "clsm-25"
  }, [_c('g', {
    staticClass: "clsm-37"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.07, 0.07, 0.01, 553.89, 443.36)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "clsm-27"
  }, [_c('g', {
    staticClass: "clsm-37"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.06, -0.07, 0, 681.96, 352.51)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0, 0.07, -0.07, 0, 677.73, 424.12)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "600.8 322.3 593 324.7 598.3 360.9 606.1 359.8 600.8 322.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "647.7 324.1 655.4 327 647.4 362.7 639.7 361 647.7 324.1"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "clsm-25"
  }, [_c('g', {
    staticClass: "clsm-38"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.07, 0.07, 0.01, 553.89, 443.36)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "clsm-27"
  }, [_c('g', {
    staticClass: "clsm-39"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.06, -0.07, 0, 681.96, 352.51)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0, 0.07, -0.07, 0, 677.73, 424.12)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "586.9",
      "cy": "335.2",
      "r": "7.3",
      "transform": "matrix(0.95, -0.31, 0.31, 0.95, -74.38, 195.47)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M581.5,400.1l-7.2-17.8a16.5,16.5,0,0,1,9.1-21.5c8.4-3.4,11.3,2.4,14.7,10.9a10.7,10.7,0,0,1,.5,7.1l-.3,21.1a9,9,0,0,1-16.7.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M575,388.4l-.4-1-.3-.8-.6-1.6-1.1-3.2c-.7-2.1-1.3-4.3-1.8-6.5a76.1,76.1,0,0,1-2.1-14,52.5,52.5,0,0,1,.2-7.9,40.1,40.1,0,0,1,1.9-8.7,30.3,30.3,0,0,1,4.9-9,29.4,29.4,0,0,1,8.1-7.1l13.8,22.9-.4.6a4.4,4.4,0,0,0-.4,1.2,14.3,14.3,0,0,0-.4,2.6,25.9,25.9,0,0,0,.1,3.6,49,49,0,0,0,1.8,8.7c.4,1.5.9,3,1.5,4.5l.9,2.2.4,1.1.2.5.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M573.6,372.7l-.3-.5-.2-.3-.3-.5-.5-.9-.9-1.8a34.7,34.7,0,0,1-1.4-3.7,32.9,32.9,0,0,1-1.5-8.4,27.1,27.1,0,0,1,1.4-9.7l.9-2.4,1.2-2.3.6-1.1.7-1,1.5-1.9a13.4,13.4,0,0,1,18.8-1.8c5.7,4.7,3.7,20.1,3.7,20.1a79.3,79.3,0,0,0,2.5,17.2C593.5,378.1,578.1,379.3,573.6,372.7Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M650,392.8c-4.7,1.7-9.5,3.1-14.3,4.5l-14.4,4c-4.8,1.3-9.6,2.5-14.4,3.5s-9.7,2-14.6,2.6a9.6,9.6,0,0,1-3.3-18.8c4.8-1.1,9.7-1.8,14.6-2.5s9.8-1.1,14.8-1.6l14.9-1.1c5-.3,9.9-.5,15-.5a5,5,0,0,1,1.7,9.8Z"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M662.7,383.4a17.5,17.5,0,0,1-2.6,2.5,32.5,32.5,0,0,1-10.1,5.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M663.4,378.5a17.3,17.3,0,0,1-2.7,3.4,29.9,29.9,0,0,1-8.6,5.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M661.6,375.1a20.9,20.9,0,0,1-2.7,4.5c-2,2.4-5.4,4-7.7,5.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M656.4,374.6a4.1,4.1,0,0,1-.4,3.5c-1.8,2.6-6,5.4-7.8,6.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "650.8",
      "cy": "385.9",
      "r": "6.2",
      "transform": "translate(248.9 1026.9) rotate(-88.6)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M642.1,387.1a17.5,17.5,0,0,1,.1-2.1c.1-.7.2-1.3.3-2a17.9,17.9,0,0,1,1.2-3.9,12.6,12.6,0,0,1,1-1.9,6.7,6.7,0,0,1,1.6-1.8,12.4,12.4,0,0,1,3.6-1.9,1.4,1.4,0,0,1,1.1,2.6h-.1a9.3,9.3,0,0,0-2.4,1.9,2.7,2.7,0,0,0-.6,1,8.7,8.7,0,0,0-.4,1.4,13.5,13.5,0,0,0-.2,3c0,.5.1,1,.1,1.6a11.4,11.4,0,0,0,.3,1.4,2.9,2.9,0,1,1-5.8.9Z"
    }
  })]), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "660.6",
      "cy": "337.9",
      "r": "7.3",
      "transform": "translate(-58.6 520.5) rotate(-41.3)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M632,396.5l15.3-11.6a16.5,16.5,0,0,0,3.2-23.1c-5.5-7.3-10.9-3.7-18.2,1.8a10.7,10.7,0,0,0-4.1,5.9l-10.5,18.2a9,9,0,0,0,14.2,8.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M626.8,366.1l.3-.2.4-.3.9-.7,1.9-1.5,3.6-3.1a49,49,0,0,0,6-6.6,26,26,0,0,0,2-3.1,14.3,14.3,0,0,0,1-2.4,4.4,4.4,0,0,0,.2-1.2,2,2,0,0,0-.1-.7l23.6-12.6A29.4,29.4,0,0,1,670,344a30.3,30.3,0,0,1-.4,10.2,40.1,40.1,0,0,1-2.8,8.4,52.5,52.5,0,0,1-3.9,6.9,76.1,76.1,0,0,1-9,11c-1.6,1.6-3.2,3.2-4.9,4.7l-2.6,2.2-1.3,1.1-.7.6-.9.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M652.8,376.9l.5-.2.3-.2.5-.3.9-.6,1.7-1.1,3.1-2.5a32.9,32.9,0,0,0,5.6-6.5,27.1,27.1,0,0,0,3.8-9c.2-.8.3-1.7.4-2.5s.1-1.7.1-2.5,0-.9,0-1.3V349c-.1-.8-.2-1.6-.3-2.4a13.4,13.4,0,0,0-15.2-11.2c-7.3,1.1-13.5,15.4-13.5,15.4a79.3,79.3,0,0,1-11,13.5C633,371.4,645.5,380.3,652.8,376.9Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M629.5,330.8c.9,4.9,1.5,9.9,2.2,14.8s1.2,9.9,1.6,14.8.9,9.9,1.1,14.8.4,9.9.2,14.8a9.6,9.6,0,0,1-19.1.2c-.3-4.9-.2-9.9-.1-14.8s.5-9.9.9-14.8.8-9.9,1.3-14.8,1.1-9.9,1.9-14.8a5,5,0,0,1,10-.1Z"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "clsm-41",
    attrs: {
      "d": "M616.9,317.8a22.2,22.2,0,0,1,3.7,2.9c.6.9.4,1,1.6,2.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-41",
    attrs: {
      "d": "M615.1,311.6s4.1,4.9,7.5,6.6,4.7,1.4,9,2.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "621.5",
      "cy": "323.9",
      "r": "5.8",
      "transform": "translate(-79.3 316.8) rotate(-26.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M623,323.4c-.1,0,0,0,0,0h1.3l1.6-.2,1.6-.6.4-.2h.2l.5-.7a43.1,43.1,0,0,0,1.9-4.1c.3-.7.6-1.5,1.1-2.3a9.1,9.1,0,0,1,.8-1.3l.7-.8a2.6,2.6,0,0,1,1.7-.6,1.7,1.7,0,0,1-.1,3.4,1.1,1.1,0,0,0,.6-.1h-.1l-.4.8c-.2.6-.5,1.3-.7,2.1a45.9,45.9,0,0,1-1.6,4.7,9.5,9.5,0,0,1-.7,1.3l-.6.8-.5.6a11.5,11.5,0,0,1-2.3,2,12.6,12.6,0,0,1-2.8,1.3l-1.5.4h-1.8a3.5,3.5,0,1,1,.8-7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-41",
    attrs: {
      "d": "M616.6,321.5a26.9,26.9,0,0,1,3.9,3.1,14,14,0,0,1,1.9,2.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-41",
    attrs: {
      "d": "M616.1,324.8a18.2,18.2,0,0,0,4.2,3.1,9.5,9.5,0,0,1,3.6,2.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "624.2",
      "cy": "324.9",
      "r": "7.1",
      "transform": "translate(-79.4 318.1) rotate(-26.9)"
    }
  })]), _vm._v(" "), _c('circle', {
    staticClass: "clsm-14",
    attrs: {
      "cx": "622.1",
      "cy": "290.9",
      "r": "4",
      "transform": "translate(139.6 779.6) rotate(-70.4)"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "clsm-16",
    attrs: {
      "cx": "634.8",
      "cy": "293.5",
      "r": "1.8",
      "transform": "translate(145.6 793.3) rotate(-70.4)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-18",
    attrs: {
      "cx": "634.2",
      "cy": "292.7",
      "r": "0.3",
      "transform": "translate(146 792.2) rotate(-70.4)"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-19",
    attrs: {
      "d": "M636.7,293.6a1.8,1.8,0,0,0-1.2-1.8,1.8,1.8,0,0,0-2.1.6,1.8,1.8,0,1,1,3.3,1.2Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-14",
    attrs: {
      "cx": "635",
      "cy": "295.4",
      "r": "4",
      "transform": "translate(144 794.8) rotate(-70.4)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "clsm-16",
    attrs: {
      "x": "638.6",
      "y": "296.1",
      "width": "2.8",
      "height": "1.8",
      "transform": "matrix(0.33, -0.94, 0.94, 0.33, 145.74, 800.59)"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "man man--waiting",
    class: {
      active: _vm.man.waiting
    },
    attrs: {
      "id": "man_waiting"
    },
    on: {
      "click": _vm.switchPosition
    }
  }, [_c('g', [_c('path', {
    staticClass: "clsm-3",
    attrs: {
      "d": "M648.4,567.9l-6.2,48.3s-.7,17.6-.8,17.6l-.9,6.3-8.1,2.2h0l-5.3-51.1-2.3-23.8Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "636.7",
      "cy": "566.5",
      "r": "11.8"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "clsm-3",
    attrs: {
      "d": "M586.7,566.7l1.6,48.7s-.9,17.6-.9,17.6l.3,6.4,7.8,3h0l10.1-50.4,5.2-25.5Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "598.7",
      "cy": "566.4",
      "r": "12",
      "transform": "translate(-21.6 1109) rotate(-84.6)"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "clsm-4",
    attrs: {
      "points": "628.5 634.6 643.7 633.8 643.3 641.1 661.7 653 633 651.4 628.5 650.5 631.4 642.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-5",
    attrs: {
      "d": "M640.5,647.9s4-13.4,5.7-10.4-4,7.5-4,7.5l-6.8-4.9s4.8-1.1,5.8,2.8a6.9,6.9,0,0,0,4.4,4.8"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "clsm-4",
    attrs: {
      "points": "597.7 633.7 582.5 634.2 583.6 641.5 566.2 654.9 594.6 650.8 599 649.6 595.5 641.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-5",
    attrs: {
      "d": "M585.6,648.1s-5.1-13-6.5-9.9,4.6,7.2,4.6,7.2l6.3-5.5s-4.8-.7-5.6,3.2a6.9,6.9,0,0,1-4,5.1"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-3",
    attrs: {
      "points": "588.4 470.2 586.7 566.7 610.9 566.4 614.4 544.9 619.3 519.9 631.7 461.7 593.1 458.1 588.4 470.2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "610.9",
      "cy": "466.1",
      "r": "21.8"
    }
  }), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "clsm-3",
    attrs: {
      "points": "656 471.7 648.5 566.8 625 565.1 623.2 543.6 620.6 518.3 613.8 459.1 652.5 459.1 656 471.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "636.6",
      "cy": "566.5",
      "r": "11.8"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "631.9",
      "cy": "466.1",
      "r": "21.8"
    }
  })]), _vm._v(" "), _c('circle', {
    staticClass: "clsm-3",
    attrs: {
      "cx": "621.4",
      "cy": "459.3",
      "r": "31.4"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "588.5",
      "cy": "341.1",
      "r": "14.2",
      "transform": "translate(243.4 927.3) rotate(-89.6)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "651.5",
      "cy": "339.9",
      "r": "14.2",
      "transform": "translate(307.2 989.1) rotate(-89.6)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M619.7,352l22.8-27-24.9-9.1s-21.3,10.3-23.1,11.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M662.3,338.5a11.2,11.2,0,0,0-5.2-8.9h-.2a11.1,11.1,0,0,0-3.5-1.4l-18.2-7s-2.8,15.1-14.8,16.7h-1c-12.1-1.1-15.5-16.1-15.5-16.1l-17.9,7.7a11.2,11.2,0,0,0-3.5,1.5h-.2a11.1,11.1,0,0,0,.5,18.7l2.5,118.9,74.6-1.5-2.3-118.9A11.1,11.1,0,0,0,662.3,338.5Z"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M632,299.3l-27.3.2s3.2,24.2,4.1,27.2a11,11,0,0,0,21.5-3c0-.2,0-.4,0-.5Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "618.3",
      "cy": "299.1",
      "r": "13.7",
      "transform": "translate(-2.7 5.5) rotate(-0.5)"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "clsm-42"
  }, [_c('g', {
    staticClass: "clsm-43"
  }, [_c('g', {
    staticClass: "clsm-10"
  }, [_c('g', {
    staticClass: "clsm-44"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.01, -0.03, 0.01, 646.88, 292.97)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.01, 0.02, 0.01, 593.37, 310.66)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M614.3,266.2H614c-8.5.8-21.7,11.3-14.8,25.9,2.7,5.6,3.4,11,5.7,15.4s4.9,8.5,8,10.6,3.6.9,5.7.8h.3c2.1-.2,4-.2,5.5-1.8s4.8-6.7,6-11.8S632,295,633.6,289C637.8,273.4,622.8,265.5,614.3,266.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M631.5,292.9a2.9,2.9,0,0,0-.2-1.1c-.5-1.2-1.5-2.2-1.6-3.5s.5-2.4.8-3.7a13.6,13.6,0,0,0-.9-8.5c-.6-1.5-1.9-2.8-2.4-4.3s.9-3,1.7-4.7.2-1,.4-1.2,3,2.7,3.4,3.3c2.3,3.9,2.7,8.5,2.5,12.9a82.9,82.9,0,0,1-1.5,12.8,15.4,15.4,0,0,0-.5,3c0,.5-1.7-.9-1.9-1.2S631.5,294.1,631.5,292.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M601,295.6a2.9,2.9,0,0,1,0-1.1c.2-1.3,1-2.4,1-3.8s-.9-2.3-1.5-3.5a13.6,13.6,0,0,1-.6-8.5c.4-1.6,1.2-3.1,1.4-4.7s0-3.9-1.3-5.2a1.4,1.4,0,0,0-1.7-.2c-.9.4-2.4,3.3-2.7,3.9-1.6,4.2-1.3,8.7-.3,13a82.9,82.9,0,0,0,3.7,12.3,15.4,15.4,0,0,1,1,2.8c.1.5,1.6-1.1,1.7-1.5S601.2,296.8,601,295.6Z"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-13",
    attrs: {
      "points": "594.9 275.1 593.1 284 595.9 282.5"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-13",
    attrs: {
      "points": "598.9 278.2 602.2 279.9 601.4 272.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-13",
    attrs: {
      "d": "M636.1,263.1c-2.4-.1-4.5.5-6.9-.3-4.1-1.3-7.9-3.7-12.3-4.1a21,21,0,0,0-13.5,3.1,15.2,15.2,0,0,0-5.2,6.6v.2c-.3,4.3,3.5,5.1,5.3,5.2a12.2,12.2,0,0,0,2,0,18.1,18.1,0,0,1,3.6.7,43.7,43.7,0,0,1,7,2.4,25.3,25.3,0,0,0,5.3,2.2c2.1.5,4.9,1,7-.4a12.2,12.2,0,0,1-2.7-2,11.4,11.4,0,0,1-1.7-2.4c1,.7,2.2,1.3,3.1,1.9a4.8,4.8,0,0,0,4.2,0c2.3-1.2,4.5-5.6,4.9-8.3h-1.3C635.6,266.5,636.5,264.4,636.1,263.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-15",
    attrs: {
      "d": "M613.6,291.2a3.9,3.9,0,0,1,4.8-.4"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "clsm-16",
    attrs: {
      "x": "603.3",
      "y": "291.8",
      "width": "1.8",
      "height": "2.78",
      "transform": "translate(-23.7 54.9) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "clsm-15",
    attrs: {
      "x1": "603.7",
      "y1": "293.3",
      "x2": "597.4",
      "y2": "295.2"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "clsm-15",
    attrs: {
      "x1": "627.9",
      "y1": "290.8",
      "x2": "633.7",
      "y2": "291.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-17",
    attrs: {
      "points": "626.9 284.3 622.6 283.5 618.6 284.8"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "clsm-17",
    attrs: {
      "points": "604.7 286.5 607.3 284.2 611.5 284.7"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "clsm-16",
    attrs: {
      "cx": "611",
      "cy": "291.4",
      "r": "1.8",
      "transform": "translate(-23.5 55.5) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-18",
    attrs: {
      "cx": "610.3",
      "cy": "290.9",
      "r": "0.3",
      "transform": "translate(-23.4 55.4) rotate(-5.1)"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-19",
    attrs: {
      "d": "M610.5,290.8a1.8,1.8,0,0,0-1.9-1.1,1.8,1.8,0,0,0-1.7,1.4,1.8,1.8,0,1,1,3.5-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-20",
    attrs: {
      "d": "M616.4,302.5l5-2a29.5,29.5,0,0,0-6-8.4Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-20",
    attrs: {
      "cx": "616",
      "cy": "300.8",
      "r": "1.8",
      "transform": "translate(-24.3 56) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-21",
    attrs: {
      "d": "M625.1,309.5l-1.2-4.5-4.2-2.7-2.1.7-2.2-.2-3.6,3.5-.2,4.2-8.5-7.4a19.6,19.6,0,0,0,2.6,8.3c2.4,3.9,6.6,8.7,11,7.8l2.3-.4h2.3c4.6.1,7.8-5.4,9.5-9.7a15.9,15.9,0,0,0,.7-8.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-31",
    attrs: {
      "points": "614.9 307.1 618.2 305.2 618.5 306.8 619.7 305.5 621.6 309.2 614.9 307.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-31",
    attrs: {
      "points": "615 308 617.3 311.8 621.2 309.6 617.9 308.4 615 308"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M631,293c.5.4,2.4-2.6,3.3-2.8s1.5.6,1.8,1.1a4.5,4.5,0,0,1,.5,2.6c-.2,3.7-3.2,7.3-7.1,6.6.1-.2.2-.1.4,0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-12",
    attrs: {
      "d": "M601.4,295.7c-.4.5-2.8-2.1-3.8-2.1s-1.4.9-1.6,1.4a4.5,4.5,0,0,0,0,2.6c.8,3.6,4.4,6.6,8.2,5.2-.1-.2-.2,0-.4.1"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "clsm-45"
  }, [_c('g', {
    staticClass: "clsm-10"
  }, [_c('g', {
    staticClass: "clsm-46"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.02, -0.03, 0, 649.68, 254.08)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.01, 0.02, 0.02, 597.32, 286.84)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "596.1 323.4 588.3 326.2 595.7 362.1 603.4 360.5 596.1 323.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "643 322.5 650.8 325 644.8 361.1 637 359.9 643 322.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-24",
    attrs: {
      "d": "M652,397.6c-3.3-5.4-3.4-21.2-3.4-21.2l-.4-20.5-56.2,1.1.4,20.5s.6,15.7-2.6,21.3a14.1,14.1,0,0,1-8.7,7l2.7,138.6,16.9-.3,46-.9,16.9-.3L661,404.3A14.1,14.1,0,0,1,652,397.6Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "clsm-25"
  }, [_c('g', {
    staticClass: "clsm-47"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.07, 0.07, 0.01, 556.01, 446.92)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "clsm-27"
  }, [_c('g', {
    staticClass: "clsm-47"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.06, -0.07, 0.01, 678.75, 348.99)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0, 0.07, -0.07, 0.01, 678.57, 420.72)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "596.1 323.4 588.3 326.2 595.7 362.1 603.4 360.5 596.1 323.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "clsm-24",
    attrs: {
      "points": "643 322.5 650.8 325 644.8 361.1 637 359.9 643 322.5"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "clsm-25"
  }, [_c('g', {
    staticClass: "clsm-48"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.07, 0.07, 0.01, 556.01, 446.92)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "clsm-27"
  }, [_c('g', {
    staticClass: "clsm-49"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.06, -0.07, 0.01, 678.75, 348.99)",
      "xlink:href": "#image-2"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "transform": "matrix(0, 0.07, -0.07, 0.01, 678.57, 420.72)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M546.3,386.9l3.7-18.8a16.5,16.5,0,0,1,19.3-13c8.9,1.8,8.1,8.2,6.4,17.1a10.7,10.7,0,0,1-3.5,6.2l-11.8,17.4a9,9,0,0,1-14.1-9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M547.3,373.6l.2-1.1.2-.9.4-1.7.9-3.3c.6-2.2,1.3-4.3,2.1-6.4a76.1,76.1,0,0,1,5.9-12.9,52.5,52.5,0,0,1,4.5-6.5,40.1,40.1,0,0,1,6.4-6.3,30.3,30.3,0,0,1,9-4.9,29.4,29.4,0,0,1,10.7-1.5l-1,26.7-.7.2-1,.8a14.3,14.3,0,0,0-1.7,2,25.9,25.9,0,0,0-1.9,3.1,49,49,0,0,0-3.3,8.2c-.5,1.5-.9,3.1-1.2,4.6l-.5,2.3-.2,1.1v.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M554.7,359.7v-2.6c.1-.7.2-1.3.3-2a34.7,34.7,0,0,1,.9-3.9,32.9,32.9,0,0,1,3.4-7.9,27.1,27.1,0,0,1,6.5-7.4l2.1-1.5,2.2-1.2,1.1-.6,1.1-.4,2.3-.8a13.4,13.4,0,0,1,16.8,8.8c2.2,7.1-7.9,18.9-7.9,18.9a79.3,79.3,0,0,0-7.3,15.8C568.4,375.1,554.9,367.6,554.7,359.7Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M578.6,444.9c-3.1-4-5.9-8-8.8-12.1s-5.6-8.2-8.3-12.4-5.3-8.4-7.8-12.6-4.9-8.6-7-13.1a9.6,9.6,0,0,1,16.9-9c2.5,4.3,4.7,8.7,6.9,13.1s4.1,9,6.1,13.6,3.8,9.2,5.7,13.8,3.6,9.3,5.2,14a5,5,0,0,1-8.8,4.7Z"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M574.4,453.9a9.4,9.4,0,0,1-1.2-4.7c.1-1.9.8-9.4,7.4-7.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M575.3,455.8s-2.4-2.2-.9-4.2,2.6-6.2,4.9-7.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M578.5,456.5s-3.5-2.1-2.2-4.3,1.3-4.9,3.4-6.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M581.3,456.6s-2.7-3.2-1.8-4.9,1.5-4.8,3.2-5.9"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "579.9",
      "cy": "444.7",
      "r": "6.2",
      "transform": "translate(-50.6 75.3) rotate(-7.1)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M586.5,438.2a19.4,19.4,0,0,0,.9,2.1l1.1,2.1a12,12,0,0,1,.8,1.2l.6.8a1.8,1.8,0,0,0,1,.7h.3a1.4,1.4,0,0,1,0,2.7,4,4,0,0,1-2-.2,5.6,5.6,0,0,1-1.6-.9l-1.1-1-.8-.8-2.1-1.7-2-2h-.1a3,3,0,0,1,4.5-4A3.1,3.1,0,0,1,586.5,438.2Z"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('circle', {
    staticClass: "clsm-6",
    attrs: {
      "cx": "656.4",
      "cy": "335.6",
      "r": "7.3",
      "transform": "translate(-65.5 186.1) rotate(-15.4)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M696.5,386.9l-3.7-18.8a16.5,16.5,0,0,0-19.3-13c-8.9,1.8-8.1,8.2-6.4,17.1a10.7,10.7,0,0,0,3.5,6.2l11.8,17.4a9,9,0,0,0,14.1-9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M666.9,378.3v-.9l-.2-1.1-.5-2.3c-.4-1.6-.8-3.1-1.2-4.6a49,49,0,0,0-3.3-8.2,25.9,25.9,0,0,0-1.9-3.1,14.3,14.3,0,0,0-1.7-2l-1-.8-.7-.2-1-26.7a29.4,29.4,0,0,1,10.7,1.5,30.3,30.3,0,0,1,9,4.9,40.1,40.1,0,0,1,6.4,6.3,52.5,52.5,0,0,1,4.5,6.5,76.1,76.1,0,0,1,5.9,12.9c.8,2.1,1.4,4.3,2.1,6.4l.9,3.3.4,1.7.2.9.2,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-6",
    attrs: {
      "d": "M688,359.7v-2.6c-.1-.7-.2-1.3-.3-2a34.7,34.7,0,0,0-.9-3.9,32.9,32.9,0,0,0-3.4-7.9,27.1,27.1,0,0,0-6.5-7.4l-2.1-1.5-2.2-1.2-1.1-.6-1.1-.4-2.3-.8a13.4,13.4,0,0,0-16.8,8.8c-2.2,7.1,7.9,18.9,7.9,18.9a79.3,79.3,0,0,1,7.3,15.8C674.4,375.1,687.9,367.6,688,359.7Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M651.4,437.4c2-4.6,4.1-9.1,6.3-13.6s4.4-8.9,6.8-13.3,4.7-8.8,7.2-13,5.1-8.5,7.9-12.5a9.6,9.6,0,0,1,16.1,10.3c-2.5,4.3-5.3,8.4-8.1,12.4s-5.8,8-8.8,11.9-6.1,7.8-9.2,11.7-6.3,7.7-9.7,11.4a5,5,0,0,1-8.4-5.4Z"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M673.3,441.9a17.5,17.5,0,0,0-2.2-2.8,32.5,32.5,0,0,0-9.2-6.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M673.2,446.9a17.3,17.3,0,0,0-2.2-3.8,29.9,29.9,0,0,0-7.7-6.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M670.9,449.9a20.9,20.9,0,0,0-2-4.8c-1.7-2.7-4.7-4.8-6.8-6.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-40",
    attrs: {
      "d": "M665.7,449.6a4.1,4.1,0,0,0,.1-3.5c-1.4-2.8-5.1-6.2-6.8-7.4"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-7",
    attrs: {
      "cx": "661.8",
      "cy": "437.7",
      "r": "6.2",
      "transform": "translate(145.5 1040.2) rotate(-82.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "clsm-7",
    attrs: {
      "d": "M659,436.7a11.4,11.4,0,0,0-.5,1.4c-.1.5-.3,1-.4,1.5a13.5,13.5,0,0,0-.2,3,8.7,8.7,0,0,0,.2,1.4,2.7,2.7,0,0,0,.4,1.1,9.3,9.3,0,0,0,2.1,2.2h0a1.4,1.4,0,0,1-1.5,2.4,12.4,12.4,0,0,1-3.3-2.4,6.6,6.6,0,0,1-1.4-2,12.6,12.6,0,0,1-.7-2,17.9,17.9,0,0,1-.6-4.1c0-.7,0-1.4,0-2a17.5,17.5,0,0,1,.2-2.1V435a2.9,2.9,0,1,1,5.8,1A3.1,3.1,0,0,1,659,436.7Z"
    }
  })])]), _vm._v(" "), _c('circle', {
    staticClass: "clsm-14",
    attrs: {
      "cx": "609.3",
      "cy": "292.9",
      "r": "4",
      "transform": "translate(-23.6 55.3) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "clsm-16",
    attrs: {
      "cx": "623.8",
      "cy": "290",
      "r": "1.8",
      "transform": "translate(-23.3 56.6) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-18",
    attrs: {
      "cx": "622.9",
      "cy": "289.5",
      "r": "0.3",
      "transform": "translate(-23.3 56.6) rotate(-5.1)"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "clsm-19",
    attrs: {
      "d": "M623.6,289.3a1.8,1.8,0,0,0-1.9-1.1,1.8,1.8,0,0,0-1.7,1.4,1.8,1.8,0,1,1,3.5-.3Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clsm-14",
    attrs: {
      "cx": "622.9",
      "cy": "291.6",
      "r": "4",
      "transform": "translate(-23.5 56.5) rotate(-5.1)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "clsm-16",
    attrs: {
      "x": "627.2",
      "y": "289.7",
      "width": "1.8",
      "height": "2.78",
      "transform": "translate(-23.4 57) rotate(-5.1)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb01c260"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_elements/Man.vue
// module id = 573
// module chunks = 1